let menuButtonMobile = document.querySelector('.header__cartInfoMobileButton'),
    searchLink = document.querySelector('.header__cartInfoSearch'),
    noticeLinks = document.querySelectorAll('.notice__links a'),
    menuLinks = document.querySelectorAll('.header__navigationFirstItem'),
    manuLinksUrl = document.querySelectorAll('.header__navigationFirstItem a'),
    headerLogoLink = document.querySelector('.header__logo span'),
    accountLink = document.querySelector('.header__cartInfoAccount'),
    accountMenu = document.querySelector('.header__navigationDropdownItem[data-menu-link="Account"]'),
    secondLevelMenusArray = document.querySelectorAll('.header__navigationSecond__inner'),
    headerWrapper = document.querySelector('.header__wrapper'),
    headerSection = document.querySelector('.headerSection'),
    cartIcon = document.querySelector('.header__cartInfoLink'),
    overlap = document.querySelector('.overlap'),
    body = document.querySelector('body'),
    heroModules = document.querySelector('.heroModules');

if (menuButtonMobile) {
  menuButtonMobile.addEventListener('click', toggleMobileMenu);

  function toggleMobileMenu() {
    let header = document.querySelector('.header'),
        body = document.querySelector('body'),
        navigation = document.querySelector('.header__navigation'),
        noticeBar = document.querySelector('.noticeList'),
        logo = document.querySelector('.header__logo'),
        darkHeader = document.querySelector('.header.header--dark');

    if (header.classList.contains('headerMenu--active')) {
      setTimeout(() => {header.classList.remove('headerMenu--active')}, 600);
    } else if (!header.classList.contains('transparent-header')) {
      header.classList.add('headerMenu--active');
    }

    if (!menuButtonMobile.classList.contains('header__cartInfoMobileButton--active')) {
      let secondLevelActive = document.querySelector('.header__navigation.header__mobileNavigationSecond--active');

      menuButtonMobile.classList.add('header__cartInfoMobileButton--active');
      body.classList.add('overflow');

      setTimeout(() => {
        navigation.style.height = window.innerHeight - noticeBar.scrollHeight + 'px';
        navigation.classList.add('header__navigation--active');
      }, 200);

      if (secondLevelActive) {
        secondLevelActive.classList.remove('header__mobileNavigationSecond--active');
      }

      if (darkHeader) {
        darkHeader.classList.add('header--blackText');
      } else {
        header.classList.add('header--whiteText');
      }
    } else {
      let activeSecondLevelMenu = document.querySelector('.header__navigationSecond.header__navigationSecond--active');

      menuButtonMobile.classList.remove('header__cartInfoMobileButton--active');

      setTimeout(() => {
        navigation.classList.remove('header__navigation--active');
      }, 1000);

      navigation.style.height = '0px';
      body.classList.remove('overflow');

      if (logo.classList.contains('logo--active')) {
        logo.classList.remove('logo--active');
      }

      if (activeSecondLevelMenu) {
        activeSecondLevelMenu.classList.remove('header__navigationSecond--active');
      }

      if (darkHeader) {
        darkHeader.classList.remove('header--blackText');
      } else {
        header.classList.remove('header--whiteText');
      }
    }
  }
}

if (cartIcon && window.innerWidth > 768) {
  cartIcon.addEventListener('mouseenter', () => {
    closeMenus();
  });
}

if (searchLink) {
  let closeSearchButton = document.querySelector('.header__searchFormClose');

  searchLink.addEventListener('click', openSearchBar);
  closeSearchButton.addEventListener('click', closeSearchBar);

  searchLink.addEventListener('mouseenter', () => {
    addBackground();
    closeMenus();
  });

  searchLink.addEventListener('mouseleave', () => {
    removeBackground();
  });

  function openSearchBar() {
    let searchForm = document.querySelector('.header__searchForm'),
        navigation = document.querySelector('.header__navigation'),
        mobileMenuButton = document.querySelector('.header__cartInfoMobileButton'),
        searchField = document.querySelector('.header__searchFormField');

    if (mobileMenuButton && navigation && navigation.classList.contains('header__navigation--active')) {
      mobileMenuButton.click();
      setTimeout(() => {
        searchForm.classList.add('header__searchForm--active');
      }, 800);
    } else {
      searchForm.classList.add('header__searchForm--active');
      setTimeout(() => {
        searchField.focus();
      }, 300);
    }
  }

  function closeSearchBar() {
    let searchForm = document.querySelector('.header__searchForm');

    searchForm.classList.remove('header__searchForm--active');
  }
}

if (noticeLinks.length > 0) {
  let termsCloseButtonsArray = document.querySelectorAll('.header__termsButton');

  function closeTermsSection() {
    let openedSection = document.querySelector('.header__terms.header__terms--active');

    openedSection.classList.remove('header__terms--active');
    overlap.classList.remove('overlap--active');
    body.classList.remove('body--overflow');
  }

  function openTermsLink(event, hash) {
    let currentTermsContent = document.querySelector(`.header__terms[data-terms-link="${hash}"]`);

    if (currentTermsContent) {
      event.preventDefault();
      currentTermsContent.classList.add('header__terms--active');
      overlap.classList.add('overlap--active');
      body.classList.add('body--overflow');
    }
  }

  noticeLinks.forEach(link => {
    link.addEventListener('click', event => {
      openTermsLink(event, link.hash);
    });
  });

  termsCloseButtonsArray.forEach(button => {
    button.addEventListener('click', closeTermsSection);
  });
}

if (menuLinks.length > 0) {
  if (window.innerWidth > 768) {
    function toggleSecondLevelMenu(event) {
      let currentLink = event.currentTarget,
          currentLinkDataset = currentLink.dataset.menuLink,
          currentMenu = document.querySelector(`.header__navigationDropdownItem[data-menu-link="${currentLinkDataset}"]`),
          darkHeader = document.querySelector('.header.header--dark'),
          collectionFullpageWrapperInner = document.querySelector('.collectionFullpage__wrapperInner');

      if (currentMenu && event.type == 'mouseenter') {
        let dropdownSection = document.querySelector('.header__navigationDropdown'),
            activeNavItem = document.querySelector('.header__navigationFirstItem.header__navigationSecond--active'),
            activeDropdownItem = document.querySelector('.header__navigationDropdownItem.header__navigationDropdownItem--active'),
            activeAccountLink = document.querySelector('.header__navigationSecond--active'),
            activeAccountMenu = document.querySelector('.header__navigationAccount.header__navigationSecond--active'),
            header = document.querySelector('.header');

        if (activeAccountMenu) {
          activeAccountMenu.classList.remove('header__navigationSecond--active');
          activeAccountMenu.style.maxHeight = '0px';
        }

        if (activeAccountLink) {
          activeAccountLink.classList.remove('header__navigationSecond--active');
        }

        if (activeDropdownItem) {
          activeDropdownItem.classList.remove('header__navigationDropdownItem--active');
        }

        if (activeNavItem) {
          activeNavItem.classList.remove('header__navigationSecond--active');
        }

        if (darkHeader) {
          darkHeader.classList.add('header--blackText');
        } else {
          header.classList.add('header--whiteText');
        }

        removeBackground();
        currentLink.classList.add('header__navigationSecond--active');
        currentMenu.classList.add('header__navigationDropdownItem--active');
        dropdownSection.style.height = `${currentMenu.scrollHeight}px`;
        collectionFullpageWrapperInner?.classList.add('collectionFullpage__wrapperInner--hidden');
      }

      if (!currentMenu && event.type == 'mouseenter') {
        addBackground();
        closeMenus();
      }

      if (!currentMenu && event.type == 'mouseleave') {
        removeBackground();
        collectionFullpageWrapperInner?.classList.remove('collectionFullpage__wrapperInner--hidden');
      }
    }

    function removeBackground() {
      if (headerWrapper.classList.contains('header__wrapper--background')) {
        headerWrapper.classList.remove('header__wrapper--background');
      }
    }

    function addBackground() {
      if (!headerWrapper.classList.contains('header__wrapper--background')) {
        headerWrapper.classList.add('header__wrapper--background');
      }
    }

    function closeMenus() {
      let activeMenuLink = document.querySelector('.header__navigationFirstItem.header__navigationSecond--active'),
          activeAccountLink = document.querySelector('.header__cartInfoAccount.header__navigationSecond--active'),
          activeMenu = document.querySelector('.header__navigationDropdownItem.header__navigationDropdownItem--active'),
          activeAccountMenu = document.querySelector('.header__navigationAccount.header__navigationSecond--active'),
          darkHeader = document.querySelector('.header.header--dark.header--blackText'),
          dropdownSection = document.querySelector('.header__navigationDropdown'),
          header = document.querySelector('.header'),
          collectionFullpageWrapperInner = document.querySelector('.collectionFullpage__wrapperInner');

      if (activeMenuLink) {
        activeMenuLink.classList.remove('header__navigationSecond--active');
      }

      if (header.classList.contains('transparent-header')) {
        header.classList.remove('headerMenu--active');
      }

      if (activeAccountLink) {
        activeAccountLink.classList.remove('header__navigationSecond--active');
      }

      if (activeMenu) {
        activeMenu.classList.remove('header__navigationDropdownItem--active');
        dropdownSection.style.height = '0px';
      }

      if (activeAccountMenu) {
        activeAccountMenu.classList.remove('header__navigationSecond--active');
        dropdownSection.style.height = '0px';
      }

      if (darkHeader) {
        darkHeader.classList.remove('header--blackText');
      } else {
        header.classList.remove('header--whiteText');
      }

      collectionFullpageWrapperInner?.classList.remove('collectionFullpage__wrapperInner--hidden');
    }

    menuLinks.forEach(link => {
      link.addEventListener('mouseenter', event => {
        toggleSecondLevelMenu(event);
      });
    });

    menuLinks.forEach(link => {
      link.addEventListener('mouseleave', event => {
        toggleSecondLevelMenu(event);
      });
    });

    headerWrapper.addEventListener('mouseleave', event => {
      closeMenus();
    });
  }

  if (window.innerWidth <= 768 && window.innerWidth > 640) {
    function showSecondLevelMenu(event) {
      let currentLink = event.currentTarget,
          currentLinkWrapper = currentLink.closest('li'),
          secondLevelMenu = currentLinkWrapper.querySelector('.header__navigationSecond');

      if (secondLevelMenu) {
        let activeSubmenu = document.querySelector('.header__navigationSecond.header__navigationSecond--active'),
            activeLink = document.querySelector('.header__navigationFirstItem.header__navigationFirstItem--linkActive')

        event.preventDefault();

        if (activeSubmenu) {
          activeSubmenu.classList.remove('header__navigationSecond--active')
        }

        if (activeLink) {
          activeLink.classList.remove('header__navigationFirstItem--linkActive');
        }

        currentLink.classList.add('header__navigationFirstItem--linkActive');
        secondLevelMenu.classList.add('header__navigationSecond--active');
      }
    }

    function closeSecondLevelMenu() {
      let activeMenu = document.querySelector('.header__navigationSecond.header__navigationSecond--active');

      activeMenu.classList.remove('header__navigationSecond--active');
    }

    headerLogoLink.addEventListener('click', closeSecondLevelMenu);

    menuLinks.forEach(link => {
      link.addEventListener('click', event => {
        showSecondLevelMenu(event);
      })
    });
  }

  if (window.innerWidth <= 640) {
    let secondLevelLinksArray = document.querySelectorAll('.header__navigationItem');

    function closeMenu() {
      let activeLogo = document.querySelector('.header__logo.logo--active'),
          activeNavigation = document.querySelector('.header__navigation.header__navigation--active');

      activeLogo.classList.remove('logo--active');
      activeNavigation.style.height = '0px';

      setTimeout(() => {
        activeNavigation.classList.remove('header__navigation--active');
      }, 200);

      if (header.classList.contains('transparent-header')) {
        header.classList.remove('headerMenu--active');
      }
    }

    function showSecondLevelMenu(event) {
      let currentLink = event.currentTarget,
          currentLinkWrapper = currentLink.closest('li'),
          secondLevelMenu = currentLinkWrapper.querySelector('.header__navigationSecond'),
          logo = document.querySelector('.header__logo');

      if (secondLevelMenu) {
        let firstLevelMenu = document.querySelector('.header__navigation.header__navigation--active');

        event.preventDefault();
        secondLevelMenu.classList.add('header__navigationSecond--active');
        logo.classList.add('logo--active');
        firstLevelMenu.classList.add('header__mobileNavigationSecond--active');
      }
    }

    function closeSecondLevelMenu() {
      let activeMenu = document.querySelector('.header__navigationSecond.header__navigationSecond--active'),
          secondLevelActive = document.querySelector('.header__navigation.header__navigation--active.header__mobileNavigationSecond--active'),
          logo = document.querySelector('.header__logo');

      activeMenu.classList.remove('header__navigationSecond--active');

      logo.classList.remove('logo--active');

      if (secondLevelActive) {
        secondLevelActive.classList.remove('header__mobileNavigationSecond--active')
      }
    }

    headerLogoLink.addEventListener('click', closeSecondLevelMenu);

    secondLevelLinksArray.forEach(link => {
      link.addEventListener('click', event => {
        if (event.currentTarget.querySelector('a').href.includes('#')) {
          return
        }

        let activeNavigation = document.querySelector('.header__navigation--active');
        let activeNavigationSecond = document.querySelector('.header__navigationSecond--active');

        activeNavigation.style.height = '0';
        activeNavigationSecond.style.height = '0';
      })
    })

    manuLinksUrl.forEach(link => {
      link.addEventListener('click', event => {
        showSecondLevelMenu(event);
      })
    });
  }
}

if (accountLink && accountMenu) {
  function showAccountMenu(event) {
    let darkHeader = document.querySelector('.header.header--dark'),
        header = document.querySelector('.header');

    if (event.type == 'mouseover') {
      let secondMenuActive = document.querySelector('.header__navigationDropdownItem.header__navigationDropdownItem--active'),
          dropdownSection = document.querySelector('.header__navigationDropdown');

      if (secondMenuActive) {
        let activeLink = document.querySelector('.header__navigationFirstItem.header__navigationSecond--active');

        if (activeLink) {
          activeLink.classList.remove('header__navigationSecond--active');
        }

        secondMenuActive.classList.remove('header__navigationDropdownItem--active');
        dropdownSection.style.height = `${accountMenu.scrollHeight}px`;
      }

      if (darkHeader) {
        darkHeader.classList.add('header--blackText');
      } else {
        header.classList.add('header--whiteText');
      }

      accountMenu.classList.add('header__navigationDropdownItem--active');
      event.currentTarget.classList.add('header__navigationSecond--active');
      dropdownSection.style.height = `${accountMenu.scrollHeight}px`;

      removeBackground();
    }
  }

  function changeAccountLink(event) {
    let darkHeader = document.querySelector('.header.header--dark'),
        header = document.querySelector('.header');

    if (event.type == 'mouseover' && darkHeader) {
      darkHeader.classList.add('header--blackText');
    } else {
      header.classList.add('header--whiteText');
    }
  }

  accountLink.addEventListener('mouseover', event => showAccountMenu(event));
  accountLink.addEventListener('mouseleave', () => removeBackground());
  accountMenu.addEventListener('mouseover', event => changeAccountLink(event));
  accountMenu.addEventListener('mouseleave', () => removeBackground());
}

window.toggleContentGap = function() {
  document.addEventListener('DOMContentLoaded', () => {
    if (
        window.location.href.includes('/products')
        || window.location.href.includes('/fw22-lp')
      ) {
      if (window.innerWidth <= 640 && document.querySelector('.noticeList')) {
        headerSection.style.marginTop = `${Math.floor(document.querySelector('.noticeList').scrollHeight / 2)}px`;
      }
    } else if (window.location.pathname == '/') {
      headerSection.style.marginTop = `${(Math.floor(document.querySelector('.noticeList').scrollHeight / 2) - 5)}px`;
    } else if (
      window.location.pathname == '/'
      || document.querySelector('.editorialFull__wrapper--padding')
      || document.querySelector('.popupVideo__wrapper')
      || document.querySelector('.page-marzocco-template')
      || document.querySelector('.article-content-redesign')
    ) {
      headerSection.style.marginTop = `${document.querySelector('.noticeList').scrollHeight}px`;
    } else if (window.location.href.includes('pages/regenerative')) {
      headerSection.style.marginTop = `${headerSection.clientHeight}px`;
    } else if (window.location.href.includes('/fw22-lp')) {
      headerSection.style.marginTop = `0px`;
    } else {
      headerSection.style.marginTop = `${document.querySelector('.noticeList').clientHeight + document.querySelector('.header__wrapper').clientHeight}px`;
    }
  });
}

window.toggleContentGap();
